module.exports = __webpack_public_path__ + "static/media/click-save.acfe0a11.png";